import React from "react";
import { useTranslation } from 'react-i18next';
import NewWindow from "./NewWindow";
import { useDispatch } from "react-redux";
import { authorizePayment, cancelExternalRedirect } from "../actions/checkoutActions";

export default function ExternalRedirectPayment(props) {

    const { t } = useTranslation();
    let { orderResponse} = props;
    const dispatch = useDispatch();
    const [closePaymentRedirection, setClosePaymentRedirection] = React.useState((props.payByMobilePay || props.payByKlarna) ? false : true);
    const onCloseWindow = (event) => {
        dispatch(cancelExternalRedirect());
    }
 
    const handleExternalRedirectPayment = (event) => {

            if (event.data&& event.data.message === 'external-redirect-authentication-complete') {
                setClosePaymentRedirection(false);
                const externalRedirectPaymentOptions = {
                    paymentIntent: event.data.paymentIntent,
                    paymentIntentClientSecret: event.data.paymentIntentClientSecret,
                    sourceType: event.data.sourceType
                };
                dispatch(authorizePayment(externalRedirectPaymentOptions));
                //.then(res => {
                //    // DO Something
                //})
                if (props.onPaymentComplete); {
                    props.onPaymentComplete();
                }
            }  

    };


    React.useEffect(() => {
        window.addEventListener('message', handleExternalRedirectPayment);
        // cleanup this component
        return () => {
            window.removeEventListener('message', handleExternalRedirectPayment);
        };

    }, []);
    let url = orderResponse.paymentProviderRedirectURL, title = t("PaymentConfirmation3DS");
    if (props.payByKlarna === true) {
        url = props.klarnaLoadingUrl;
        title = t("PaymentConfirmationKlarna");
    }
    else if (props.payByMobilePay === true) {
        url = props.mobilePayLoadingUrl;
        title = t("PaymentConfirmationMobilePay");
    }
    const customModalClass = (props.isKlarnaWindowOpen || props.isMobilePayWindowOpen) ? "window-overlay-only" : "";
    return <NewWindow autoSize={false} customModalClass={customModalClass} title={`${title}`} open={(orderResponse.requiresActionExternalRedirect || props.isKlarnaWindowOpen || props.isMobilePayWindowOpen)} showCloseIcon={closePaymentRedirection} onClose={onCloseWindow} closeOnOverlayClick={false}>
            <div className="iframe-container" dangerouslySetInnerHTML={{ __html: `<iframe frameBorder="0" src='${url}' class='responsive-iframe' />` }} />
        </NewWindow> ;

}
